// extracted by mini-css-extract-plugin
module.exports = {"cookies":"cookies_cookies__WGNAE","container":"cookies_container__x7aiZ","text":"cookies_text__Myi7P","link":"cookies_link__YbSA5"};